<template>
  <model-list-select v-if="!loading" :list="selects" v-model="customerId" option-value="id" option-text="customerable"
    :custom-text="getCustomerName" :isDisabled="disabled" :placeholder="first">
  </model-list-select>
  <div v-else class="form-control" style="background-color: #f8f9fa; color: #6c757d;">
    Carregando Clientes...
  </div>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import ModelListSelect from 'vue-search-select/src/lib/ModelListSelect';

export default {
  name: 'SelectCustomers',
  components: { ModelListSelect },
  data() {
    return {
      customerId: 0,
      firstOption: this.first ? this.first : 'Todas',
      selects: [],
      loading: false,
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    filteredClient: {
      type: Boolean,
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.$emit('loading', true);

      if (this.filteredClient) {
        axios(`${baseApiUrl}/v1/customer/listFiltered?status=1`).then((res) => {
          this.selects = res.data;
          this.loading = false;
          this.$emit('loading', false);
        }).catch(() => {
          this.loading = false;
          this.$emit('loading', false);
        });
      } else {
        axios(`${baseApiUrl}/v1/customer/all?order=name`).then((res) => {
          this.selects = res.data;
          this.loading = false;
          this.$emit('loading', false);
        }).catch(() => {
          this.loading = false;
          this.$emit('loading', false);
        });
      }
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
    getCustomerName(customer) {
      return `${customer.id} - ${customer.customerable.name}`;
    },
  },
  watch: {
    customerId() {
      this.$emit('change', this.customerId);
    },
    selected() {
      this.customerId = this.selected;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
